import { render, staticRenderFns } from "./LoginTip.vue?vue&type=template&id=0740ce61&scoped=true"
import script from "./LoginTip.vue?vue&type=script&lang=js"
export * from "./LoginTip.vue?vue&type=script&lang=js"
import style0 from "./LoginTip.vue?vue&type=style&index=0&id=0740ce61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0740ce61",
  null
  
)

export default component.exports